import { get } from '@common/utils/dataProxy';

import { Company, CompanyApiItem } from './types';

export const fetchKycPassed = async (): Promise<boolean> => {
  const profile = (await get('/v3/users/security/profile')) as {
    kycDetailStatus?: number;
  };
  return profile?.kycDetailStatus === 2;
};

export const fetchCompanies = async (): Promise<Company[]> => {
  const companies =
    ((await get('/v2/support/shareholders/companies')) as CompanyApiItem[]) ??
    [];
  return companies.map((item) => ({
    id: item.companyId,
    nameJa: item.companyName,
    logoUrl: item.logoUrl,
    landingPageUrl: item.landingPageUrl || undefined,
  }));
};
